import saveAs from 'file-saver';

/**
 * extract filename and download file.
 * @param {Object} response
 * @param {string} fileName
 * @returns {void}
 */
export const downloadFile = (response, fileName) => {
  let downloadFileName;
  if (!fileName) {
    const disposition = response.headers['content-disposition'];
    if (disposition?.indexOf?.('attachment') !== -1) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches?.[1]) {
        downloadFileName = matches[1].replace(/['"]/g, '');
      }
    }
  }

  saveAs(response.data, fileName || downloadFileName);
};

/**
 * Returns the data portion of the blob error response from axios
 * @deprecated This function is flawed. It takes the failure response and tries to handle it as if it were a success
 * @param {Object} error Error response
 * @param {Object} error.response API error response
 * @returns {Promise} Promise object represents JSON parse error.response.data Data portion of API response
 */
export const handleErrorOnBlobs = error =>
  new Promise(resolve => {
    const reader = new FileReader();
    const onload = function () {
      resolve(JSON.parse(this.result));
    };

    reader.onload = onload;

    reader.readAsText(error.response?.data);
    handleErrorOnBlobs.reader = reader;
  });
